import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcVeryDissatisfied = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 10.0002,
			cy: 10.0002,
			r: 7.85714,
			fill: "#2B3E64"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0002 10.3569C8.14658 10.3569 7.47099 11.7313 7.24555 12.442C7.20404 12.5729 7.37741 12.6849 7.49937 12.6219C7.90214 12.4137 8.68008 12.1426 10.0002 12.1426C11.3203 12.1426 12.0983 12.4137 12.501 12.6219C12.623 12.6849 12.7964 12.5729 12.7549 12.442C12.5294 11.7313 11.8538 10.3569 10.0002 10.3569Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.65791 7.51075C8.84926 7.55859 8.96561 7.75249 8.91777 7.94385C8.76697 8.54703 8.05171 9.64294 6.42843 9.64294C6.23119 9.64294 6.07129 9.48304 6.07129 9.2858C6.07129 9.08855 6.23119 8.92866 6.42843 8.92866C7.6623 8.92866 8.13751 8.11981 8.22481 7.77061C8.27265 7.57925 8.46655 7.46291 8.65791 7.51075Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.3421 7.51075C11.1507 7.55859 11.0344 7.75249 11.0822 7.94385C11.233 8.54703 11.9483 9.64294 13.5716 9.64294C13.7688 9.64294 13.9287 9.48304 13.9287 9.2858C13.9287 9.08855 13.7688 8.92866 13.5716 8.92866C12.3377 8.92866 11.8625 8.11981 11.7752 7.77061C11.7274 7.57925 11.5334 7.46291 11.3421 7.51075Z",
			fill: "white"
		})
	]
});
export default SvgIcVeryDissatisfied;
